module.exports = __webpack_public_path__ + "static/media/en-data-roaming-other_4.e217bac2.png";